import { render } from "./VNPay.vue?vue&type=template&id=784dd30a&scoped=true"
import script from "./VNPay.vue?vue&type=script&lang=js"
export * from "./VNPay.vue?vue&type=script&lang=js"

import "./VNPay.vue?vue&type=style&index=0&id=784dd30a&scoped=true&lang=css"

import exportComponent from "/vercel/path0/my_res/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-784dd30a"]])

export default __exports__